import {Client} from '@/app/features/cliente/models/cliente.interface';
import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {Occupation} from '@/app/features/ocupaciones/services/occupation.interface';
import {Departament} from '@/app/features/departamentos/services/departament.interface';
import {inject} from '@angular/core';
import {ClientSessionService} from '@/app/features/cliente/services/cliente-session.service';

export interface ClientState  {
  client: Client | null;
  occupations: Occupation[];
  departaments: Departament[];
  campaigns: any[];
}

function loadClientFromLocalStorage(): Client | null {
  try {
    const raw = localStorage.getItem('currentClient');
    return raw ? JSON.parse(raw) as Client : null;
  } catch {
    return null;
  }
}

export const initialState: ClientState = {
  client: loadClientFromLocalStorage(),
  occupations: [],
  departaments: [],
  campaigns: [],
};

export const ClientStore = signalStore(
  {providedIn: 'root'},
  withState(initialState),
  withMethods((store) => {
    const clientSessionService = inject(ClientSessionService);
    return {
        setClient: (newClient: Client) => {
          patchState(store, {
            client: newClient
          });
          clientSessionService.setClient(newClient);
        },
        setOccupations: (ocupations: Occupation[]) => {
          patchState(store, {
            occupations: ocupations
          });
        },
        setDepartaments: (departaments: Departament[]) => {
          patchState(store, {
            departaments: departaments
          });
        },
        setCampaigns: (campaigns: any[]) => {
          patchState(store, {
            campaigns: campaigns
          });
        },
        resetData(){
          patchState(store, {client: null, occupations: [], departaments: [], campaigns: []});
          localStorage.removeItem('currentClient');
        }
      }
  })
)
